import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Global scroll-reset on route change.
 * Every React Router navigation resets the scroll position to the top
 * of the document so users never land mid-page after clicking a link.
 *
 * Uses "auto" behaviour on route changes (users expect an instant reset
 * on navigation — smooth scroll during navigation feels laggy). Smooth
 * scrolling remains active for the floating scroll-nav and in-page
 * anchors via `scroll-behavior: smooth` in CSS.
 */
const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Skip if the URL includes a hash fragment (in-page anchor).
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
